import {validateDatoCmsTypes} from './common.serde'
import {parseFontAwesomeIcon} from './icon.serde'
import {OfferingDataFieldsFragment, OfferingFieldsFragment} from '../../../../__generated__/datocms.types'
import {Offering} from '../types/offering.types'

export function parseOffering(o?: OfferingDataFieldsFragment | OfferingFieldsFragment): Offering {
  if (!o) {
    throw new Error('Failed to parse offering: `o` is undefined')
  }

  switch (o.__typename) {
    case 'OfferingDataModelRecord': {
      const offering = validateDatoCmsTypes(o)

      return {
        id: offering.id.toString(),
        cmsId: offering.cmsId,
        title: offering.label,
        clientFacingTitle: offering.clientFacingLabel,
        icon: offering.icon ? parseFontAwesomeIcon(offering.icon) : undefined,
        industryPage: offering.industryPage
          ? {
              slug: offering.industryPage.slug!,
              title: offering.industryPage.breadcrumbTitle || offering.industryPage.title!,
              proDirectoryIndustriesIds:
                offering.industryPage.proDirectoryIndustries
                  ?.split(',')
                  .filter(id => id.length > 0)
                  .map(id => id.trim()) ?? [],
            }
          : undefined,
      }
    }
    case 'OfferingModelRecord': {
      const offering = validateDatoCmsTypes(o)

      return {
        id: offering.offeringId,
        title: offering.title,
        icon: offering.icon ? parseFontAwesomeIcon(offering.icon) : undefined,
      }
    }
    default:
      throw new RangeError('Offering type name is not supported')
  }
}
